import React, { createContext, useState, useContext } from 'react';
import CustomDialog from './CustomDialog';

type DialogType = 'alert' | 'confirm' | 'prompt';

interface DialogOptions {
  type: DialogType;
  message: string;
  onConfirm?: (value?: string) => void;
  onCancel?: () => void;
  confirmButton?: string;
  cancelButton?: string;
  title?: string; // Optional title for the dialog
  danger?: boolean; // Optional flag for danger styling
}

const DialogContext = createContext<(options: DialogOptions) => void>(() => {});

export const useDialog = () => useContext(DialogContext);

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [options, setOptions] = useState<DialogOptions | null>(null);

  const showDialog = (opts: DialogOptions) => {
    setOptions(opts);
  };

  const close = () => setOptions(null);

  return (
    <DialogContext.Provider value={showDialog}>
      {children}
      {options && (
        <CustomDialog
          type={options.type}
          message={options.message}
          title={options.title} // 🔧 hinzufügen
          danger={options.danger} // 🔧 hinzufüge  n
          onConfirm={(val) => {
            options.onConfirm?.(val);
            close();
          }}
          onCancel={() => {
            options.onCancel?.();
            close();
          }}
          onClose={close}
          confirmButton={options.confirmButton} // 🔧 hinzufügen
          cancelButton={options.cancelButton}   // 🔧 hinzufügen
        />
      )}
    </DialogContext.Provider>
  );
};